export function generateRequestId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    const reqId = crypto.randomUUID();
    return reqId;
  }

  // Fallback: time-stamp + random slug (still unique enough per call)
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
